import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from '../../common/ui/Loader';
import Locations from '../companyDetails/Tabs/Locations';
import Workers from '../companyDetails/Tabs/Workers';
import Payment from '../companyDetails/Tabs/Payment';
import { pushHistoryState, stripHash } from '../../../helpers/routing';
import { getCompanyLocations, getLocationsListAction } from '../../../actions/locations';
import { getCompanyLTAWorkers, getCompanyFavAndBlocks, addCompanyLTAWorker, removeCompanyLTAWorker,
  deleteCompanyWorker, createCompanyWorker, updateCompanyWorker, getCompanyDetailsAction, getCompanyPaymentAction,
  createStripeCustomerWithCard, deletePaymentInfo } from '../../../actions/companies';
import { clearWorkersPredictionsList, searchWorkersAction, searchWorkersForFavorites } from '../../../actions/users';
import { UIShowAlert, UIShowConfirm } from '../../../actions/ui';
import defaultUserPhoto from '../../../images/default_user.png';

const profileTabs = {
  locations: 'Locations',
  workers: 'Workers',
  payment: 'Payment Method'
};

class Profile extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    companyLocations: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    getCompanyDetailsAction: PropTypes.func.isRequired,
    getCompanyPaymentAction: PropTypes.func.isRequired,
    getCompanyLocations: PropTypes.func.isRequired,
    getLocationsListAction: PropTypes.func.isRequired,
    getCompanyLTAWorkers: PropTypes.func.isRequired,
    getCompanyFavAndBlocks: PropTypes.func.isRequired,
    searchWorkersAction: PropTypes.func.isRequired,
    searchWorkersForFavorites: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    addCompanyLTAWorker: PropTypes.func.isRequired,
    removeCompanyLTAWorker: PropTypes.func.isRequired,
    deleteCompanyWorker: PropTypes.func.isRequired,
    createCompanyWorker: PropTypes.func.isRequired,
    updateCompanyWorker: PropTypes.func.isRequired,
    UIShowAlert: PropTypes.func.isRequired,
    UIShowConfirm: PropTypes.func.isRequired,
    createStripeCustomerWithCard: PropTypes.func.isRequired,
    deletePaymentInfo: PropTypes.func.isRequired
  };

  state = {
    activeTab: null,
    isLoading: false
  };

  componentDidMount () {
    this.props.getCompanyDetailsAction().then(this._setDataLoaded());
  }

  _setDataLoaded = () => {
    const hash = stripHash(this.props.location.hash);
    if (Object.values(profileTabs).includes(hash)) {
      this.setState({ activeTab: hash });
    } else {
      this.setState({ activeTab: profileTabs.locations });
    }

    this.setState({ isLoading: false });
  };

  setActiveTab = (activeTab, event) => {
    event.preventDefault();
    this.setState({ activeTab });
    pushHistoryState(`${this.props.match.url}#${activeTab}`);
  };

  _renderTabs = () => {
    let RenderTab = null;

    switch (this.state.activeTab) {
      case profileTabs.locations:
        RenderTab = Locations;
        break;
      case profileTabs.workers:
        RenderTab = Workers;
        break;
      case profileTabs.payment:
        RenderTab = Payment;
        break;
      default:
        return null;
    }

    return <RenderTab {...this.props} />;
  };

  render () {
    if (this.state.isLoading) {
      return <Loader />;
    }
    const { activeTab } = this.state;
    const { location, user } = this.props;
    const { photo_image_url, first_name, last_name, email, phone } = user;

    return (
      <div>
        <div className='d-flex mb-4'>
          <div
            className='image-icon'
            style={{ backgroundImage: `url('${photo_image_url || defaultUserPhoto}')` }}
          />
          <div>
            <h3 className='mb-2'>{first_name} {last_name}</h3>
            <p>Email: {email}</p>
            <p>Phone: {phone}</p>
          </div>
        </div>
        <ul className='nav nav-tabs mt-1'>
          {Object.values(profileTabs).map(tab => (
            <li className='nav-item' key={tab}>
              <a onClick={event => this.setActiveTab(tab, event)}
                href={`${location.pathname}#${tab}`}
                className={`nav-link ${activeTab === tab && 'active'}`}
              >{tab}</a>
            </li>
          ))}
        </ul>

        <ul className='list-group flex-1'>
          <li className='list-group-item list-group-item-content border-top-0 pt-4 border-radius-top-0'>
            {this._renderTabs()}
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    company: state.companies.companyDetails,
    companyLocations: state.companyLocations,
    locationsList: state.locations.locationsList,
    workersPredictionsList: state.users.workersPredictionsList
  };
};

const mapDispatchToProps = {
  getCompanyDetailsAction,
  getCompanyPaymentAction,
  getCompanyLocations,
  getLocationsListAction,
  getCompanyLTAWorkers,
  getCompanyFavAndBlocks,
  searchWorkersAction,
  searchWorkersForFavorites,
  clearWorkersPredictionsList,
  addCompanyLTAWorker,
  removeCompanyLTAWorker,
  deleteCompanyWorker,
  createCompanyWorker,
  updateCompanyWorker,
  UIShowAlert,
  UIShowConfirm,
  createStripeCustomerWithCard,
  deletePaymentInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/components/app/profile/index.js